import { defineMeta } from '../../../../define';

export default defineMeta({
  id: 'js-async-boss',
  slug: 'boss',
  title: 'Retry with backoff',
  type: 'boss',
  estSeconds: 1200,
  contentVersion: 1,
});
